import { CheckEmailIconSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/check-email-icon-svg/check-email-icon-svg.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AlertService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '../../../../../../_services/_iam/paperless.service';
import { PolicyDataService } from '../../../../../../_services/my-insurance/data-services/policy-data.service';
import { UserService } from '../../../../../../_services/user.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';
import { PaperlessDataService } from '../../../../../../_services/data-services/paperless-data.service';
import { AgentNotificationService } from '../../../../../../_services/agent/agent-notification.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent, CheckEmailIconSvgComponent],
  selector: 'app-paperless-policy',
  templateUrl: './paperless-policy.component.html',
})
export class PaperlessPolicyComponent implements OnInit {
  endEnrollOptionsModal: ModalOptions;
  enrollOptionsModal: ModalOptions;
  hideModal = false;
  policyInfo: any;
  user: any;

  constructor(
    private alertService: AlertService,
    private paperlessService: PaperlessService,
    private policyDataService: PolicyDataService,
    private userService: UserService,
    private errorRedirectionService: ErrorRedirectionService,
    private paperlessDataService: PaperlessDataService,
    private agentNotification: AgentNotificationService
  ) {
    this.endEnrollOptionsModal = this.paperlessDataService.getRemovalModel(
      'modal-medium cancel-enroll modal-dialog',
      'red-text float-right align-middle flat no-padding no-margin',
      'MODAL_E-POLICY-REMOVAL_TITLE',
      'endEnrollModal',
      'MODAL_E-POLICY-REMOVAL_TITLE'
    );

    this.enrollOptionsModal = this.paperlessDataService.getEnrollModel(
      'modal-medium enroll modal-dialog',
      'no-margin float-right w-100 primary ghost',
      'ENROLL',
      'enrollModal',
      'MODAL_E-POLICY-ENROLL_TITLE'
    );
  }

  cancellEnroll(policyid, email, policy): void {
    this.agentNotification.setHeader(policy);
    this.agentNotification.setAgentInfo(policy);
    this.paperlessService.cancelPaperlessEPolicyV2(policyid, email).subscribe(
      () => {
        this.alertService.error('EPOLICY_CANCEL');
      },
      (error) => {
        this.errorRedirectionService.errorHandler(
          error,
          'PROBLEM_IN_REQUEST_PROCESSING'
        );
      }
    );
  }

  enroll(policyid, email, policy): void {
    this.agentNotification.setAgentInfo(policy);
    this.agentNotification.setHeader(policy);
    this.paperlessService.enrollPaperlessEPolicyV2(policyid, email).subscribe(
      () => {
        this.alertService.success('EPOLICY_ENROLL');
      },
      (error) => {
        this.errorRedirectionService.errorHandler(
          error,
          'PROBLEM_IN_REQUEST_PROCESSING'
        );
      }
    );
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  ngOnInit() {
    this.userService.$user.subscribe((user) => {
      this.user = user;
    });

    this.policyDataService.$policyDetails.subscribe((policyInfo) => {
      this.policyInfo = policyInfo;
    });
  }
}
